// Generated by packages/ui/scripts/build-app-sprite.mjs - do not edit manually
export const spriteUrl = '/sprite.66a6115c7215.svg' as const;
